const roi_calculator = (function ($) {
    const APP_NAME = 'roi_calc'

    const setup_progress_indicator = () => {
        const progress_wrapper = document.getElementById('roi-calculator-progress')
        if (progress_wrapper) {
            DOM.progress = progress_wrapper
        }
    }

    const DOM = {}

    const accordion_config = {
        desktop: {
            swipe: false,
            autoplay: false,
            arrows: false,
            slide: 'fieldset',
            vertical: true,
            verticalSwiping: false,
            centerMode: true,
            centerPadding: '80px',
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            draggable: false,
            accessibility: false,
        },
        mobile: {
            swipe: false,
            autoplay: false,
            arrows: false,
            slide: 'fieldset',
            vertical: false,
            verticalSwiping: false,
            centerMode: true,
            centerPadding: '80px',
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            draggable: false,
            accessibility: false,
        },
    }

    const strings = window.roi_strings || {
        tooltip_messages: {
            functional_area:
                '<p>Tell us the team you want to focus on:</p><ul><li>Enablement</li><li>Sales</li> <li>Marketing</li><li>Customer Service</li></ul>',
            improve: {
                'sales':
                    "<p>Seismic can improve multiple business areas. This calculator focuses on just one area. Select the biggest business challenge:</p><p><strong>Buyer engagement</strong>  — creating personalized and engaging content.</p><p><strong>Content automation</strong>  — automating the process of compiling and personalizing content.</p><p><strong>Content management</strong> — building, tracking, and surfacing the right content to users.</p><p><strong>Learning and coaching</strong> — ramping up reps via training and keeping them at peak performance.</p><p><strong>Enablement intelligence</strong> — tracking and analyzing content and training's impact.</p>",
                'marketing':
                    "<p>Seismic can improve multiple business areas. This calculator focuses on just one area. Select the biggest business challenge:</p><p><strong>Content automation</strong> — automating the process of compiling and personalizing content.</p><p><strong>Content management</strong> — building, tracking, and surfacing the right content to users.</p><p><strong>Enablement planning</strong> — planning and managing enablement projects for revenue impact.</p><p><strong>Enablement intelligence</strong> — tracking and analyzing content and training's impact.</p>",
                'enablement':
                    "<p>Seismic can improve multiple business areas. This calculator focuses on just one area. Select the biggest business challenge:</p><p><strong>Content management</strong> — building, tracking, and surfacing the right content to users.</p><p><strong>Enablement planning</strong> — planning and managing enablement projects for revenue impact.</p><p><strong>Enablement intelligence</strong> — tracking and analyzing content and training's impact.</p><p><strong>Learning and coaching</strong> — ramping up reps via training and keeping them at peak performance.</p>",
                'customer-service':
                    "<p>Seismic can improve multiple business areas. This calculator focuses on just one area. Select the biggest business challenge:</p><p><strong>Buyer engagement</strong> — creating personalized and engaging content.</p><p><strong>Content management</strong> — building, tracking, and surfacing the right content to users.</p><p><strong>Enablement intelligence</strong> — tracking and analyzing content and training's impact.</p><p><strong>Learning and coaching</strong> — ramping up reps via training and keeping them at peak performance.</p>",
            },
            number_of_team_members: '<p>Specify the number of team members in this functional team.</p>',
            time_spent: {
                'content-management':
                    '<p>Specify what percentage of time, on average, the team spends creating and/or finding and using sales content in a given month.</p>',
                'learning-coaching':
                    '<p>Specify what percentage of  time, on average, the team spends on training in a given month.</p>',
                'buyer-engagement':
                    '<p>Specify what percentage of  time, on average, the team spends building custom content and engaging buyers with it  in a given month.</p>',
                'content-automation':
                    '<p>Specify what percentage of  time, on average, the team spends creating personalized content in a given month.</p>',
                'enablement-planning':
                    '<p>Specify what percentage  time, on average, the team spends planning and reporting on enablement in a given month.</p>',
                'enablement-intelligence':
                    '<p>Specify what percentage of time, on average, the team spends analyzing data to determine how to grow revenue through enablement in a given month.</p>',
            },
            annual_revenue: 'Select a country currency and enter the annual sales revenue.',
            number_of_sellers: 'Enter the total number of sales people in the company or organization.',
        },
        improve_options: {
            'enablement': {
                '': 'Please select',
                'content-management': 'Content Management',
                'enablement-intelligence': 'Enablement Intelligence (analytics)',
                'enablement-planning': 'Enablement Planning',
                'learning-coaching': 'Learning & Coaching',
            },
            'sales': {
                '': 'Please select',
                'buyer-engagement': 'Buyer Engagement',
                'content-automation': 'Content Automation',
                'content-management': 'Content Management',
                'enablement-intelligence': 'Enablement Intelligence (analytics)',
                'learning-coaching': 'Learning & Coaching',
            },
            'marketing': {
                '': 'Please select',
                'content-automation': 'Content Automation',
                'content-management': 'Content Management',
                'enablement-intelligence': 'Enablement Intelligence (analytics)',
                'enablement-planning': 'Enablement Planning',
            },
            'customer-service': {
                '': 'Please select',
                'buyer-engagement': 'Buyer Engagement',
                'content-management': 'Content Management',
                'enablement-intelligence': 'Enablement Intelligence (analytics)',
                'learning-coaching': 'Learning & Coaching',
            },
        },
        team_type_text: {
            'customer-service': 'customer service',
            'enablement': 'enablement',
            'marketing': 'marketing',
            'sales': 'sales',
        },
        activity_text: {
            'content-management': 'creating and/or consuming sales content',
            'content-automation': 'creating personalized content',
            'buyer-engagement': 'building engaging content or engaging buyers with it',
            'learning-coaching': 'training people and/or creating training materials',
            'enablement-planning': 'planning and reporting on enablement',
            'enablement-intelligence': 'analyzing data to determine how to grow revenue through enablement',
        },
        summary_text: {
            functional_area: `The team's functional area is {value}`,
            improve: `The team wants to improve {value}`,
            number_of_team_members: `There are {number_of_team_members} full-time {functional_area} team members`,
            time_spent: `The team spends {value}% of their time on the area they want to improve`,
            annual_revenue: `The organization's annual revenue is {value}`,
            number_of_sellers: `There are {value} sales people in the organization.`,
        },
        view_field_tooltip: 'View Field Tooltip',
        summary_edit_screen_reader_text: `Click this link to edit value`,
        close: 'Close',
        cloning_statement:
            "That's like cloning <strong>{team_members_saved}</strong> of your team members to do {improve_text}.",
        productivity_chart_legend:
            'With the Enablement Cloud<sup>TM</sup>, your {functional_area} team could be saving <strong>{hours_saved}</strong> hours every year. {cloning_statement}',
        revenue_chart_legend:
            "Seismic doesn't just make your sales team more efficient. It makes them more effective. Your organization could be growing revenue by <strong>{revenue_expected_year_3}</strong> annually.",
        chart_strings: {
            y_axis: ['YEAR 1', 'YEAR 2', 'YEAR 3'],
            lines: {
                best: 'BEST',
                worst: 'LOWEST',
                expected: 'EXPECTED',
            },
            chart_1_title: 'INCREASE PRODUCTIVITY - HOURS SAVED',
            chart_2_title: 'REVENUE LIFT - AMOUNT INCREASED IN {currency_abbreviation}',
        },
        learning_and_coaching: 'learning and coaching',
        what_industry_are_you_in: {
            please_select: { text: 'Please select', value: '' },
            asset_management: { text: 'Asset Management', value: 'Asset Management - Traditional' },
            banking: { text: 'Banking', value: 'Banking' },
            business_services: { text: 'Business Services', value: 'Business Services' },
            consulting: { text: 'Consulting', value: 'Business Services' },
            consumer_packaged_goods: { text: 'Consumer Packaged Goods', value: 'Manufacturing - CPG' },
            healthcare_and_life_sciences: {
                text: 'Healthcare and Life Sciences',
                value: 'Medical Devices, Pharma, Life Sciences',
            },
            industrial: { text: 'Industrial', value: 'Manufacturing - CPG' },
            insurance: { text: 'Insurance', value: 'Insurance - Life & Annuity' },
            manufacturing: { text: 'Manufacturing', value: 'Manufacturing - CPG' },
            media_and_advertising: { text: 'Media and Advertising', value: 'Media and Advertising' },
            technology: { text: 'Technology', value: 'Technology' },
            telecommunications: { text: 'Telecommunications', value: 'Telecommunications' },
            wealth_management: { text: 'Wealth Management', value: 'Wealth Management' },
            other: { text: 'Other', value: 'Other - Misc' },
        },
        countries: {
            please_select: { text: 'Please select', value: '' },
            united_states: { text: 'United States', value: 'United States' },
            afghanistan: { text: 'Afghanistan', value: 'Afghanistan' },
            åland_islands: { text: 'Åland Islands', value: 'Åland Islands' },
            albania: { text: 'Albania', value: 'Albania' },
            algeria: { text: 'Algeria', value: 'Algeria' },
            american_samoa: { text: 'American Samoa', value: 'American Samoa' },
            andorra: { text: 'Andorra', value: 'Andorra' },
            angola: { text: 'Angola', value: 'Angola' },
            anguilla: { text: 'Anguilla', value: 'Anguilla' },
            antarctica: { text: 'Antarctica', value: 'Antarctica' },
            antigua_and_barbuda: { text: 'Antigua and Barbuda', value: 'Antigua and Barbuda' },
            argentina: { text: 'Argentina', value: 'Argentina' },
            armenia: { text: 'Armenia', value: 'Armenia' },
            aruba: { text: 'Aruba', value: 'Aruba' },
            australia: { text: 'Australia', value: 'Australia' },
            austria: { text: 'Austria', value: 'Austria' },
            azerbaijan: { text: 'Azerbaijan', value: 'Azerbaijan' },
            bahamas: { text: 'Bahamas', value: 'Bahamas' },
            bahrain: { text: 'Bahrain', value: 'Bahrain' },
            bangladesh: { text: 'Bangladesh', value: 'Bangladesh' },
            barbados: { text: 'Barbados', value: 'Barbados' },
            belarus: { text: 'Belarus', value: 'Belarus' },
            belgium: { text: 'Belgium', value: 'Belgium' },
            belize: { text: 'Belize', value: 'Belize' },
            benin: { text: 'Benin', value: 'Benin' },
            bermuda: { text: 'Bermuda', value: 'Bermuda' },
            bhutan: { text: 'Bhutan', value: 'Bhutan' },
            bolivia: { text: 'Bolivia', value: 'Bolivia' },
            bonaire: { text: 'Bonaire', value: 'Bonaire' },
            bosnia_and_herzegovina: { text: 'Bosnia and Herzegovina', value: 'Bosnia and Herzegovina' },
            botswana: { text: 'Botswana', value: 'Botswana' },
            bouvet_island: { text: 'Bouvet Island', value: 'Bouvet Island' },
            brazil: { text: 'Brazil', value: 'Brazil' },
            british_indian_ocean_territory: {
                text: 'British Indian Ocean Territory',
                value: 'British Indian Ocean Territory',
            },
            brunei_darussalam: { text: 'Brunei Darussalam', value: 'Brunei Darussalam' },
            bulgaria: { text: 'Bulgaria', value: 'Bulgaria' },
            burkina_faso: { text: 'Burkina Faso', value: 'Burkina Faso' },
            burundi: { text: 'Burundi', value: 'Burundi' },
            cambodia: { text: 'Cambodia', value: 'Cambodia' },
            cameroon: { text: 'Cameroon', value: 'Cameroon' },
            canada: { text: 'Canada', value: 'Canada' },
            cape_verde: { text: 'Cape Verde', value: 'Cape Verde' },
            cayman_islands: { text: 'Cayman Islands', value: 'Cayman Islands' },
            central_african_republic: { text: 'Central African Republic', value: 'Central African Republic' },
            chad: { text: 'Chad', value: 'Chad' },
            chile: { text: 'Chile', value: 'Chile' },
            china: { text: 'China', value: 'China' },
            christmas_island: { text: 'Christmas Island', value: 'Christmas Island' },
            cocos_keeling_islands: { text: 'Cocos (keeling) Islands', value: 'Cocos (keeling) Islands' },
            colombia: { text: 'Colombia', value: 'Colombia' },
            comoros: { text: 'Comoros', value: 'Comoros' },
            congo: { text: 'Congo', value: 'Congo' },
            congo_the_democratic_republic_of_the: {
                text: 'Congo, The Democratic Republic of The',
                value: 'Congo, The Democratic Republic of The',
            },
            cook_islands: { text: 'Cook Islands', value: 'Cook Islands' },
            costa_rica: { text: 'Costa Rica', value: 'Costa Rica' },
            côte_d_ivoire: { text: "Côte D'ivoire", value: "Côte D'ivoire" },
            croatia: { text: 'Croatia', value: 'Croatia' },
            cuba: { text: 'Cuba', value: 'Cuba' },
            curaçao: { text: 'Curaçao', value: 'Curaçao' },
            cyprus: { text: 'Cyprus', value: 'Cyprus' },
            czechia: { text: 'Czechia', value: 'Czechia' },
            denmark: { text: 'Denmark', value: 'Denmark' },
            djibouti: { text: 'Djibouti', value: 'Djibouti' },
            dominica: { text: 'Dominica', value: 'Dominica' },
            dominican_republic: { text: 'Dominican Republic', value: 'Dominican Republic' },
            ecuador: { text: 'Ecuador', value: 'Ecuador' },
            egypt: { text: 'Egypt', value: 'Egypt' },
            el_salvador: { text: 'El Salvador', value: 'El Salvador' },
            equatorial_guinea: { text: 'Equatorial Guinea', value: 'Equatorial Guinea' },
            eritrea: { text: 'Eritrea', value: 'Eritrea' },
            estonia: { text: 'Estonia', value: 'Estonia' },
            ethiopia: { text: 'Ethiopia', value: 'Ethiopia' },
            falkland_islands_malvinas: { text: 'Falkland Islands (malvinas)', value: 'Falkland Islands (malvinas)' },
            faroe_islands: { text: 'Faroe Islands', value: 'Faroe Islands' },
            fiji: { text: 'Fiji', value: 'Fiji' },
            finland: { text: 'Finland', value: 'Finland' },
            france: { text: 'France', value: 'France' },
            french_guiana: { text: 'French Guiana', value: 'French Guiana' },
            french_polynesia: { text: 'French Polynesia', value: 'French Polynesia' },
            french_southern_territories: { text: 'French Southern Territories', value: 'French Southern Territories' },
            gabon: { text: 'Gabon', value: 'Gabon' },
            gambia: { text: 'Gambia', value: 'Gambia' },
            georgia: { text: 'Georgia', value: 'Georgia' },
            germany: { text: 'Germany', value: 'Germany' },
            ghana: { text: 'Ghana', value: 'Ghana' },
            gibraltar: { text: 'Gibraltar', value: 'Gibraltar' },
            greece: { text: 'Greece', value: 'Greece' },
            greenland: { text: 'Greenland', value: 'Greenland' },
            grenada: { text: 'Grenada', value: 'Grenada' },
            guadeloupe: { text: 'Guadeloupe', value: 'Guadeloupe' },
            guam: { text: 'Guam', value: 'Guam' },
            guatemala: { text: 'Guatemala', value: 'Guatemala' },
            guernsey: { text: 'Guernsey', value: 'Guernsey' },
            guinea: { text: 'Guinea', value: 'Guinea' },
            guinea_bissau: { text: 'Guinea-bissau', value: 'Guinea-bissau' },
            guyana: { text: 'Guyana', value: 'Guyana' },
            haiti: { text: 'Haiti', value: 'Haiti' },
            heard_island_and_mcdonald_islands: {
                text: 'Heard Island and Mcdonald Islands',
                value: 'Heard Island and Mcdonald Islands',
            },
            holy_see_vatican_city_state: {
                text: 'Holy See (vatican City State)',
                value: 'Holy See (vatican City State)',
            },
            honduras: { text: 'Honduras', value: 'Honduras' },
            hong_kong: { text: 'Hong Kong', value: 'Hong Kong' },
            hungary: { text: 'Hungary', value: 'Hungary' },
            iceland: { text: 'Iceland', value: 'Iceland' },
            india: { text: 'India', value: 'India' },
            indonesia: { text: 'Indonesia', value: 'Indonesia' },
            iran_islamic_republic_of: { text: 'Iran, Islamic Republic of', value: 'Iran, Islamic Republic of' },
            iraq: { text: 'Iraq', value: 'Iraq' },
            ireland: { text: 'Ireland', value: 'Ireland' },
            isle_of_man: { text: 'Isle of Man', value: 'Isle of Man' },
            israel: { text: 'Israel', value: 'Israel' },
            italy: { text: 'Italy', value: 'Italy' },
            jamaica: { text: 'Jamaica', value: 'Jamaica' },
            japan: { text: 'Japan', value: 'Japan' },
            jersey: { text: 'Jersey', value: 'Jersey' },
            jordan: { text: 'Jordan', value: 'Jordan' },
            kazakhstan: { text: 'Kazakhstan', value: 'Kazakhstan' },
            kenya: { text: 'Kenya', value: 'Kenya' },
            kiribati: { text: 'Kiribati', value: 'Kiribati' },
            korea_democratic_people_s_republic_of: {
                text: "Korea, Democratic People's Republic of",
                value: "Korea, Democratic People's Republic of",
            },
            kosovo: { text: 'Kosovo', value: 'Kosovo' },
            kuwait: { text: 'Kuwait', value: 'Kuwait' },
            kyrgyzstan: { text: 'Kyrgyzstan', value: 'Kyrgyzstan' },
            lao_people_s_democratic_republic: {
                text: "Lao People's Democratic Republic",
                value: "Lao People's Democratic Republic",
            },
            latvia: { text: 'Latvia', value: 'Latvia' },
            lebanon: { text: 'Lebanon', value: 'Lebanon' },
            lesotho: { text: 'Lesotho', value: 'Lesotho' },
            liberia: { text: 'Liberia', value: 'Liberia' },
            libya: { text: 'Libya', value: 'Libya' },
            liechtenstein: { text: 'Liechtenstein', value: 'Liechtenstein' },
            lithuania: { text: 'Lithuania', value: 'Lithuania' },
            luxembourg: { text: 'Luxembourg', value: 'Luxembourg' },
            macao: { text: 'Macao', value: 'Macao' },
            macedonia_the_former_yugoslav_republic_of: {
                text: 'Macedonia, The Former Yugoslav Republic of',
                value: 'Macedonia, The Former Yugoslav Republic of',
            },
            madagascar: { text: 'Madagascar', value: 'Madagascar' },
            malawi: { text: 'Malawi', value: 'Malawi' },
            malaysia: { text: 'Malaysia', value: 'Malaysia' },
            maldives: { text: 'Maldives', value: 'Maldives' },
            mali: { text: 'Mali', value: 'Mali' },
            malta: { text: 'Malta', value: 'Malta' },
            marshall_islands: { text: 'Marshall Islands', value: 'Marshall Islands' },
            martinique: { text: 'Martinique', value: 'Martinique' },
            mauritania: { text: 'Mauritania', value: 'Mauritania' },
            mauritius: { text: 'Mauritius', value: 'Mauritius' },
            mayotte: { text: 'Mayotte', value: 'Mayotte' },
            mexico: { text: 'Mexico', value: 'Mexico' },
            micronesia_federated_states_of: {
                text: 'Micronesia, Federated States of',
                value: 'Micronesia, Federated States of',
            },
            moldova_republic_of: { text: 'Moldova, Republic of', value: 'Moldova, Republic of' },
            monaco: { text: 'Monaco', value: 'Monaco' },
            mongolia: { text: 'Mongolia', value: 'Mongolia' },
            montenegro: { text: 'Montenegro', value: 'Montenegro' },
            montserrat: { text: 'Montserrat', value: 'Montserrat' },
            morocco: { text: 'Morocco', value: 'Morocco' },
            mozambique: { text: 'Mozambique', value: 'Mozambique' },
            myanmar: { text: 'Myanmar', value: 'Myanmar' },
            namibia: { text: 'Namibia', value: 'Namibia' },
            nauru: { text: 'Nauru', value: 'Nauru' },
            nepal: { text: 'Nepal', value: 'Nepal' },
            netherlands: { text: 'Netherlands', value: 'Netherlands' },
            netherlands_antilles: { text: 'Netherlands Antilles', value: 'Netherlands Antilles' },
            new_caledonia: { text: 'New Caledonia', value: 'New Caledonia' },
            new_zealand: { text: 'New Zealand', value: 'New Zealand' },
            nicaragua: { text: 'Nicaragua', value: 'Nicaragua' },
            niger: { text: 'Niger', value: 'Niger' },
            nigeria: { text: 'Nigeria', value: 'Nigeria' },
            niue: { text: 'Niue', value: 'Niue' },
            norfolk_island: { text: 'Norfolk Island', value: 'Norfolk Island' },
            northern_mariana_islands: { text: 'Northern Mariana Islands', value: 'Northern Mariana Islands' },
            norway: { text: 'Norway', value: 'Norway' },
            oman: { text: 'Oman', value: 'Oman' },
            pakistan: { text: 'Pakistan', value: 'Pakistan' },
            palau: { text: 'Palau', value: 'Palau' },
            palestine_state_of: { text: 'Palestine, State of', value: 'Palestine, State of' },
            panama: { text: 'Panama', value: 'Panama' },
            papua_new_guinea: { text: 'Papua New Guinea', value: 'Papua New Guinea' },
            paraguay: { text: 'Paraguay', value: 'Paraguay' },
            peru: { text: 'Peru', value: 'Peru' },
            philippines: { text: 'Philippines', value: 'Philippines' },
            pitcairn: { text: 'Pitcairn', value: 'Pitcairn' },
            poland: { text: 'Poland', value: 'Poland' },
            portugal: { text: 'Portugal', value: 'Portugal' },
            puerto_rico: { text: 'Puerto Rico', value: 'Puerto Rico' },
            qatar: { text: 'Qatar', value: 'Qatar' },
            réunion: { text: 'Réunion', value: 'Réunion' },
            romania: { text: 'Romania', value: 'Romania' },
            russian_federation: { text: 'Russian Federation', value: 'Russian Federation' },
            rwanda: { text: 'Rwanda', value: 'Rwanda' },
            saint_barthélemy: { text: 'Saint Barthélemy', value: 'Saint Barthélemy' },
            saint_helena: { text: 'Saint Helena', value: 'Saint Helena' },
            saint_kitts_and_nevis: { text: 'Saint Kitts and Nevis', value: 'Saint Kitts and Nevis' },
            saint_lucia: { text: 'Saint Lucia', value: 'Saint Lucia' },
            saint_martin_french_part: { text: 'Saint Martin (French Part)', value: 'Saint Martin (French Part)' },
            saint_pierre_and_miquelon: { text: 'Saint Pierre and Miquelon', value: 'Saint Pierre and Miquelon' },
            saint_vincent_and_the_grenadines: {
                text: 'Saint Vincent and The Grenadines',
                value: 'Saint Vincent and The Grenadines',
            },
            samoa: { text: 'Samoa', value: 'Samoa' },
            san_marino: { text: 'San Marino', value: 'San Marino' },
            sao_tome_and_principe: { text: 'Sao Tome and Principe', value: 'Sao Tome and Principe' },
            saudi_arabia: { text: 'Saudi Arabia', value: 'Saudi Arabia' },
            senegal: { text: 'Senegal', value: 'Senegal' },
            serbia: { text: 'Serbia', value: 'Serbia' },
            seychelles: { text: 'Seychelles', value: 'Seychelles' },
            sierra_leone: { text: 'Sierra Leone', value: 'Sierra Leone' },
            singapore: { text: 'Singapore', value: 'Singapore' },
            sint_maartin_dutch_part: { text: 'Sint Maartin (Dutch Part)', value: 'Sint Maartin (Dutch Part)' },
            slovakia: { text: 'Slovakia', value: 'Slovakia' },
            slovenia: { text: 'Slovenia', value: 'Slovenia' },
            solomon_islands: { text: 'Solomon Islands', value: 'Solomon Islands' },
            somalia: { text: 'Somalia', value: 'Somalia' },
            south_africa: { text: 'South Africa', value: 'South Africa' },
            south_georgia_and_the_south_sandwich_islands: {
                text: 'South Georgia and The South Sandwich Islands',
                value: 'South Georgia and The South Sandwich Islands',
            },
            south_korea: { text: 'South Korea', value: 'South Korea' },
            south_sudan: { text: 'South Sudan', value: 'South Sudan' },
            spain: { text: 'Spain', value: 'Spain' },
            sri_lanka: { text: 'Sri Lanka', value: 'Sri Lanka' },
            sudan: { text: 'Sudan', value: 'Sudan' },
            suriname: { text: 'Suriname', value: 'Suriname' },
            svalbard_and_jan_mayen: { text: 'Svalbard and Jan Mayen', value: 'Svalbard and Jan Mayen' },
            swaziland: { text: 'Swaziland', value: 'Swaziland' },
            sweden: { text: 'Sweden', value: 'Sweden' },
            switzerland: { text: 'Switzerland', value: 'Switzerland' },
            syrian_arab_republic: { text: 'Syrian Arab Republic', value: 'Syrian Arab Republic' },
            taiwan: { text: 'Taiwan', value: 'Taiwan' },
            tajikistan: { text: 'Tajikistan', value: 'Tajikistan' },
            tanzania_united_republic_of: {
                text: 'Tanzania, United Republic of',
                value: 'Tanzania, United Republic of',
            },
            thailand: { text: 'Thailand', value: 'Thailand' },
            timor_leste: { text: 'Timor-Leste', value: 'Timor-Leste' },
            togo: { text: 'Togo', value: 'Togo' },
            tokelau: { text: 'Tokelau', value: 'Tokelau' },
            tonga: { text: 'Tonga', value: 'Tonga' },
            trinidad_and_tobago: { text: 'Trinidad and Tobago', value: 'Trinidad and Tobago' },
            tunisia: { text: 'Tunisia', value: 'Tunisia' },
            turkey: { text: 'Turkey', value: 'Turkey' },
            turkmenistan: { text: 'Turkmenistan', value: 'Turkmenistan' },
            turks_and_caicos_islands: { text: 'Turks and Caicos Islands', value: 'Turks and Caicos Islands' },
            tuvalu: { text: 'Tuvalu', value: 'Tuvalu' },
            uganda: { text: 'Uganda', value: 'Uganda' },
            ukraine: { text: 'Ukraine', value: 'Ukraine' },
            united_arab_emirates: { text: 'United Arab Emirates', value: 'United Arab Emirates' },
            united_kingdom: { text: 'United Kingdom', value: 'United Kingdom' },
            united_states_minor_outlying_islands: {
                text: 'United States Minor Outlying Islands',
                value: 'United States Minor Outlying Islands',
            },
            uruguay: { text: 'Uruguay', value: 'Uruguay' },
            uzbekistan: { text: 'Uzbekistan', value: 'Uzbekistan' },
            vanuatu: { text: 'Vanuatu', value: 'Vanuatu' },
            venezuela_bolivarian_republic_of: {
                text: 'Venezuela, Bolivarian Republic of',
                value: 'Venezuela, Bolivarian Republic of',
            },
            viet_nam: { text: 'Viet Nam', value: 'Viet Nam' },
            virgin_islands_british: { text: 'Virgin Islands, British', value: 'Virgin Islands, British' },
            virgin_islands_u_s: { text: 'Virgin Islands, U.S.', value: 'Virgin Islands, U.S.' },
            wallis_and_futuna: { text: 'Wallis and Futuna', value: 'Wallis and Futuna' },
            western_sahara: { text: 'Western Sahara', value: 'Western Sahara' },
            yemen: { text: 'Yemen', value: 'Yemen' },
            zambia: { text: 'Zambia', value: 'Zambia' },
            zimbabwe: { text: 'Zimbabwe', value: 'Zimbabwe' },
        },
        us_states: {
            please_select: { text: 'Please select', value: '' },
            ak: { text: 'AK', value: 'AK' },
            al: { text: 'AL', value: 'AL' },
            ar: { text: 'AR', value: 'AR' },
            az: { text: 'AZ', value: 'AZ' },
            ca: { text: 'CA', value: 'CA' },
            co: { text: 'CO', value: 'CO' },
            ct: { text: 'CT', value: 'CT' },
            dc: { text: 'DC', value: 'DC' },
            de: { text: 'DE', value: 'DE' },
            fl: { text: 'FL', value: 'FL' },
            ga: { text: 'GA', value: 'GA' },
            hi: { text: 'HI', value: 'HI' },
            ia: { text: 'IA', value: 'IA' },
            id: { text: 'ID', value: 'ID' },
            il: { text: 'IL', value: 'IL' },
            in: { text: 'IN', value: 'IN' },
            ks: { text: 'KS', value: 'KS' },
            ky: { text: 'KY', value: 'KY' },
            la: { text: 'LA', value: 'LA' },
            ma: { text: 'MA', value: 'MA' },
            md: { text: 'MD', value: 'MD' },
            me: { text: 'ME', value: 'ME' },
            mi: { text: 'MI', value: 'MI' },
            mn: { text: 'MN', value: 'MN' },
            mo: { text: 'MO', value: 'MO' },
            ms: { text: 'MS', value: 'MS' },
            mt: { text: 'MT', value: 'MT' },
            nc: { text: 'NC', value: 'NC' },
            nd: { text: 'ND', value: 'ND' },
            ne: { text: 'NE', value: 'NE' },
            nh: { text: 'NH', value: 'NH' },
            nj: { text: 'NJ', value: 'NJ' },
            nm: { text: 'NM', value: 'NM' },
            nv: { text: 'NV', value: 'NV' },
            ny: { text: 'NY', value: 'NY' },
            oh: { text: 'OH', value: 'OH' },
            ok: { text: 'OK', value: 'OK' },
            or: { text: 'OR', value: 'OR' },
            pa: { text: 'PA', value: 'PA' },
            ri: { text: 'RI', value: 'RI' },
            sc: { text: 'SC', value: 'SC' },
            sd: { text: 'SD', value: 'SD' },
            tn: { text: 'TN', value: 'TN' },
            tx: { text: 'TX', value: 'TX' },
            ut: { text: 'UT', value: 'UT' },
            va: { text: 'VA', value: 'VA' },
            vt: { text: 'VT', value: 'VT' },
            wa: { text: 'WA', value: 'WA' },
            wi: { text: 'WI', value: 'WI' },
            wv: { text: 'WV', value: 'WV' },
            wy: { text: 'WY', value: 'WY' },
        },
        canada_provices: {
            please_select: { text: 'Please select', value: '' },
            ab: { text: 'AB', value: 'AB' },
            bc: { text: 'BC', value: 'BC' },
            mb: { text: 'MB', value: 'MB' },
            nb: { text: 'NB', value: 'NB' },
            nl: { text: 'NL', value: 'NL' },
            ns: { text: 'NS', value: 'NS' },
            nt: { text: 'NT', value: 'NT' },
            nu: { text: 'NU', value: 'NU' },
            on: { text: 'ON', value: 'ON' },
            pe: { text: 'PE', value: 'PE' },
            qc: { text: 'QC', value: 'QC' },
            sk: { text: 'SK', value: 'SK' },
            yt: { text: 'YT', value: 'YT' },
        },
        switzerland_canton: {
            please_select: { text: 'Please select', value: '' },
            ag: { text: 'AG', value: 'AG' },
            ai: { text: 'AI', value: 'AI' },
            ar: { text: 'AR', value: 'AR' },
            be: { text: 'BE', value: 'BE' },
            bl: { text: 'BL', value: 'BL' },
            bs: { text: 'BS', value: 'BS' },
            fr: { text: 'FR', value: 'FR' },
            ge: { text: 'GE', value: 'GE' },
            gl: { text: 'GL', value: 'GL' },
            gr: { text: 'GR', value: 'GR' },
            ju: { text: 'JU', value: 'JU' },
            lu: { text: 'LU', value: 'LU' },
            ne: { text: 'NE', value: 'NE' },
            nw: { text: 'NW', value: 'NW' },
            ow: { text: 'OW', value: 'OW' },
            sg: { text: 'SG', value: 'SG' },
            sh: { text: 'SH', value: 'SH' },
            so: { text: 'SO', value: 'SO' },
            sz: { text: 'SZ', value: 'SZ' },
            tg: { text: 'TG', value: 'TG' },
            ti: { text: 'TI', value: 'TI' },
            ur: { text: 'UR', value: 'UR' },
            vd: { text: 'VD', value: 'VD' },
            vs: { text: 'VS', value: 'VS' },
            zg: { text: 'ZG', value: 'ZG' },
            zh: { text: 'ZH', value: 'ZH' },
        },
        state_empty: {
            please_select: { text: 'Please select', value: '' },
        },
        validation_messages: {
            email: { text: 'Please provide a valid business email address' },
            required: { text: 'Required field' },
            captcha: { text: 'Captcha has failed, please try again later.' },
        },
    }

    const step_index_fields = 'select, [type="text"], [type="number"], [type="range"], button, a'

    const Methods = {
        init_accordion(obj = !1, config = 'desktop') {
            if (!obj || obj instanceof jQuery === false) {
                return
            }
            if (config != 'desktop' && config != 'mobile') {
                return
            }
            let is_slicked = false
            try {
                obj.slick('slickCurrentSlide')
                is_slicked = true
            } catch (e) {}
            if (is_slicked) {
                if ($(obj).hasClass('roi-accordion--show-results')) {
                    return
                }

                // Re-init:
                obj.slick('unslick')
                obj.slick(accordion_config[config])
                obj.find('button.cta-secondary-large, button.cta-primary-large').each(function () {
                    /* Do not use deprecated unbind() method */
                    /* $(this).unbind('click') */
                    $(this).off('click')
                })
                roi_calculator.update_progress_indicator('reset')
            } else {
                /* Fix Slick's broken aria-hidden logic; must bind these events before initializing. (See also: 'afterChange' event action, below.) */
                obj.on('init', function () {
                    obj.find('.slick-slide.slick-current').removeAttr('aria-hidden')
                })
                obj.on('reInit', function () {
                    obj.find('.slick-slide.slick-current').removeAttr('aria-hidden')
                })
                /* Initialize */
                obj.slick(accordion_config[config])
            }

            obj.find('button.cta-secondary-large').each(function () {
                $(this).on('click', function () {
                    const current_slide_index = obj.slick('slickCurrentSlide') - 1
                    roi_calculator.set_field_focus(current_slide_index + 1)
                    roi_calculator.update_progress_indicator(current_slide_index)
                    roi_calculator.close_tooltips()
                    if (
                        typeof sega4 == 'object' &&
                        sega4.hasOwnProperty('roiCalculator') &&
                        typeof sega4.roiCalculator.log == 'function'
                    ) {
                        sega4.roiCalculator.log('previous', current_slide_index)
                    }
                    obj.slick('slickPrev')
                })
            })

            obj.find('button.cta-primary-large').each(function () {
                $(this).on('click', function () {
                    if (roi_calculator.validate($(this)) === true) {
                        const current_slide_index = obj.slick('slickCurrentSlide') + 1
                        roi_calculator.set_field_focus(current_slide_index + 1)
                        roi_calculator.update_progress_indicator(current_slide_index)
                        roi_calculator.close_tooltips()
                        if (
                            typeof sega4 == 'object' &&
                            sega4.hasOwnProperty('roiCalculator') &&
                            typeof sega4.roiCalculator.log == 'function'
                        ) {
                            sega4.roiCalculator.log('next', current_slide_index, $(this).attr('id'))
                        }
                        obj.slick('slickNext')
                    }
                })
            })

            /* Fix Slick's broken aria-hidden logic, otherwise nothing will ever be un-hidden. (See also 'init' and 'reInit' event actions, above.) */
            obj.on('afterChange', function () {
                obj.find('.slick-slide').each(function (idx) {
                    var $t = $(this)
                    if ($t.hasClass('slick-current')) {
                        $t.removeAttr('aria-hidden')
                    } else {
                        $t.attr('aria-hidden', 'true')
                    }
                })
            })

            window.addEventListener('resize', () => {
                obj.slick('reinit')
            })
        },

        set_field_focus(current_slide_index) {
            const form = document.getElementById('roi-submission-form')
            const fields = step_index_fields
            const current_slide_wrapper = form.querySelector(`.form-step-${current_slide_index}`)

            if (!current_slide_wrapper) {
                form.querySelectorAll(fields).forEach(field => {
                    field.removeAttribute('tabindex')
                })

                return
            }

            form.querySelectorAll(fields).forEach(field => {
                field.setAttribute('tabindex', '-1')
            })

            current_slide_wrapper.querySelectorAll(fields).forEach(field => {
                field.removeAttribute('tabindex')
            })

            setTimeout(() => {
                current_slide_wrapper.querySelectorAll(fields)[0].focus()
            }, 300)
        },

        update_progress_indicator(newStep = false) {
            if (!DOM || typeof DOM.progress == 'undefined') {
                return
            }
            if (newStep != 'reset') {
                newStep = parseInt(newStep)
                if (isNaN(parseInt(newStep))) {
                    return
                }
            }
            const doneText = '(' + seismicUtilities.scrub(DOM.progress.dataset.completedLabel, 'allowspaces') + ')',
                notDoneText = '(' + seismicUtilities.scrub(DOM.progress.dataset.notCompletedLabel, 'allowspaces') + ')',
                steps = DOM.progress.querySelectorAll('li')
            if (!steps.length) {
                return
            }
            steps.forEach((step, index) => {
                const status = step.querySelector('.status')
                if (newStep === 'reset') {
                    /* reset */
                    index === 0 ? step.setAttribute('aria-current', 'step') : step.removeAttribute('aria-current')
                    step.classList.remove('completed')
                    status.textContent = notDoneText
                } else if (index === newStep) {
                    step.setAttribute('aria-current', 'step')
                    step.classList.remove('completed')
                } else {
                    step.removeAttribute('aria-current')
                    if (index < newStep) {
                        step.classList.add('completed')
                        status.textContent = doneText
                    } else {
                        step.classList.remove('completed')
                    }
                }
            })
        },

        render_charts(params) {
            const chart1_canvas = document.getElementById('roi-chart-1'),
                chart2_canvas = document.getElementById('roi-chart-2')
            if ((!chart1_canvas && !chart2_canvas) || typeof params != 'object') {
                return false
            }
            if (typeof Chart != 'function') {
                console.log('Required chart object not found.')
                return false
            }

            /* Centralize reused params that cannot be set as defaults in chart.js */
            const formatting_config = {
                borderWidth: 3,
                best: { borderColor: '#7eb742' },
                worst: { borderColor: '#9c2074' },
                expected: { borderColor: '#fe5000' },
            }

            Chart.defaults.font.size = 12
            Chart.defaults.font.family = "'Proxima Nova', sans-serif"
            Chart.defaults.font.weight = 700
            Chart.defaults.color = '#22092b'
            Chart.defaults.borderColor = '#22092b'

            /* Defaults for X axis, named confusingly */
            Chart.defaults.scales.linear.grid = { drawOnChartArea: false }

            /* Defaults for Y axis, named confusingly */
            Chart.defaults.scales.category.min = 0
            Chart.defaults.scales.category.grid = { drawOnChartArea: false }

            /* Plugins use a totally different way of setting defaults, for some reason */
            Chart.defaults.set('plugins', {
                title: {
                    display: true,
                    align: 'start',
                    padding: { top: 0, bottom: 0 },
                },
                legend: {
                    align: 'end',
                    labels: {
                        usePointStyle: true,
                        pointStyle: 'line',
                        pointStyleWidth: 12,
                        padding: 18,
                        color: '#757575',
                    },
                },
                datalabels: {
                    color: '#000',
                    align: -125,
                    offset: 0,
                    // clip: true,
                    font: {
                        weight: 800,
                        size: 12,
                    },
                    /* hide point labels except for the last one: */
                    formatter: (value, context) => {
                        if (2 === context.dataIndex && strings.chart_strings.lines.expected === context.dataset.label) {
                            return seismicUtilities.format_number(value)
                        } else {
                            return ''
                        }
                    },
                },
            })

            /* productivity */
            if (chart1_canvas) {
                let chart1 = new Chart(chart1_canvas, {
                    plugins: [ChartDataLabels],
                    type: 'line',
                    data: {
                        labels: params.labels.y_axis,
                        datasets: [
                            {
                                label: seismicUtilities.scrub(params.labels.lines.worst, 'allowspaces'),
                                data: params.chart_1.data.worst,
                                borderWidth: formatting_config.borderWidth,
                                borderColor: formatting_config.worst.borderColor,
                                pointBackgroundColor: formatting_config.worst.borderColor,
                            },
                            {
                                label: seismicUtilities.scrub(params.labels.lines.expected, 'allowspaces'),
                                data: params.chart_1.data.expected,
                                borderWidth: formatting_config.borderWidth,
                                borderColor: formatting_config.expected.borderColor,
                                pointBackgroundColor: formatting_config.expected.borderColor,
                            },
                            {
                                label: seismicUtilities.scrub(params.labels.lines.best, 'allowspaces'),
                                data: params.chart_1.data.best,
                                borderWidth: formatting_config.borderWidth,
                                borderColor: formatting_config.best.borderColor,
                                pointBackgroundColor: formatting_config.best.borderColor,
                            },
                        ],
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        // layout: {
                        //     padding: {
                        //         right: 50,
                        //     },
                        // },
                        plugins: {
                            title: {
                                text: seismicUtilities.scrub(params.chart_1.title, 'allowspaces'),
                            },
                        },
                        // scales: {
                        //     y: {
                        //         // Lets not set min, max since we don't know where the calculated values will fall
                        //         min: 0,
                        //         max: 20000,
                        //         ticks: {
                        //             stepSize: 5000,
                        //         },
                        //     },
                        // },
                    },
                })
            }

            if (chart2_canvas) {
                /* revenue */
                let chart2 = new Chart(chart2_canvas, {
                    plugins: [ChartDataLabels],
                    type: 'line',
                    data: {
                        labels: params.labels.y_axis,
                        datasets: [
                            {
                                label: seismicUtilities.scrub(params.labels.lines.worst, 'allowspaces'),
                                data: params.chart_2.data.worst,
                                borderWidth: formatting_config.borderWidth,
                                borderColor: formatting_config.worst.borderColor,
                                pointBackgroundColor: formatting_config.worst.borderColor,
                            },
                            {
                                label: seismicUtilities.scrub(params.labels.lines.expected, 'allowspaces'),
                                data: params.chart_2.data.expected,
                                borderWidth: formatting_config.borderWidth,
                                borderColor: formatting_config.expected.borderColor,
                                pointBackgroundColor: formatting_config.expected.borderColor,
                            },
                            {
                                label: seismicUtilities.scrub(params.labels.lines.best, 'allowspaces'),
                                data: params.chart_2.data.best,
                                borderWidth: formatting_config.borderWidth,
                                borderColor: formatting_config.best.borderColor,
                                pointBackgroundColor: formatting_config.best.borderColor,
                            },
                        ],
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            title: {
                                text: seismicUtilities.scrub(params.chart_2.title, 'allowspaces'),
                            },
                        },
                        // scales: {
                        //     y: {
                        //         // Lets not set min, max since we don't know where the calculated values will fall
                        //         min: 0,
                        //         max: 12500000,
                        //         ticks: {
                        //             stepSize: 2500000,
                        //         },
                        //     },
                        // },
                    },
                })
            }
        },

        close_tooltips() {
            document.querySelectorAll('[role="tooltip"]:not(.hidden)').forEach(tip => {
                tip.classList.add('hidden')
                tip.removeAttribute('tabindex')
            })
        },

        /**
         * Bound to the 'next' buttons in this.init_accordion
         *
         * @param {object} step 'Next' button jQuery object
         * @returns {boolean}   Also manages error formatting and aria-invalid attribute(s)
         */
        validate(step = false) {
            if (step === false || step instanceof jQuery === false) {
                return
            }
            const error_class = 'has-error'
            let fieldset = (required_stuff = false)
            let invalid_items = []

            fieldset = step.closest('fieldset.step-wrapper')
            if (!fieldset.length) {
                return
            }
            required_stuff = fieldset.find('.is-required[data-novalidate!="true"]')
            if (!required_stuff.length) {
                return
            }
            required_stuff.each(function () {
                const This = $(this)
                const input_vector = !This.hasClass('revenue-currency-field') ? 'select, input' : 'input#annual_revenue'
                const field = This.find(input_vector)

                if (!field.length) return

                const is_select = field.prop('nodeName') === 'SELECT'
                const is_text = field.attr('type') === 'text'
                const is_email = field.attr('type') === 'email'
                const val = field.val().trim()
                let email_error_message = strings.validation_messages.email.text
                let is_valid

                if (is_select || is_text) {
                    is_valid = val !== ''
                } else if (is_email) {
                    is_valid = val !== '' && is_valid_email_address(field) && is_email_address(field)
                    if (val === '') email_error_message = strings.validation_messages.required.text
                } else {
                    is_valid = val !== '' && !isNaN(parseInt(val)) && parseInt(val) !== 0
                }

                if (!is_valid) {
                    if (is_email) field.closest('.acf-field').find('.roi-required').html(email_error_message)

                    field.attr('aria-invalid', 'true')
                    This.addClass(error_class)
                    invalid_items.push(field.attr('id'))
                    field.on('change', function () {
                        let T = $(this)
                        if (T.val() != '') {
                            T.removeAttr('aria-invalid')
                            T.closest('.' + error_class).removeClass(error_class)
                        }
                    })
                } else {
                    field.removeAttr('aria-invalid')
                    This.removeClass(error_class)
                }
            })

            if (invalid_items.length) {
                document.getElementById(invalid_items[0]).focus()
            }
            return !invalid_items.length
        },
    }

    const setup_increment_buttons = () => {
        const increment_wrappers = document.querySelectorAll('.increment-buttons')

        function store_incremement_value(id, value) {
            sessionStorage.setItem(`${APP_NAME}.${id}`, value)
        }

        increment_wrappers.forEach(wrapper => {
            wrapper.querySelector('.cta-action-button-minus').addEventListener('click', e => {
                let input_field = e.target.closest('.acf-input-wrap').querySelector('[data-type="number"]')
                let input_value = parseInt(`${input_field.value}`.replace(/[,.]/g, ''))

                // input_field.value = input_value % 10 ? Math.floor(input_value / 10) * 10 : (input_value -= 10)
                input_field.value = display_number((input_value -= 1))

                if (input_field.value <= 0 || isNaN(input_value)) {
                    input_field.value = 1
                }
                store_incremement_value(input_field.id, input_field.value)
            })

            wrapper.querySelector('.cta-action-button-plus').addEventListener('click', e => {
                let input_field = e.target.closest('.acf-input-wrap').querySelector('[data-type="number"]')
                let input_value = parseInt(`${input_field.value}`.replace(/[,.]/g, ''))

                if (isNaN(input_value)) {
                    input_field.value = 1
                } else {
                    // input_field.value = input_value % 10 ? Math.ceil(input_value / 10) * 10 : (input_value += 10)
                    input_field.value = display_number((input_value += 1))
                }
                store_incremement_value(input_field.id, input_field.value)
            })

            const number_input = wrapper.querySelector('[data-type="number"]')
            store_incremement_value(number_input.id, number_input.value)

            number_input.addEventListener('input', e => {
                store_incremement_value(e.target.id, e.target.value)
            })
        })
    }

    const setup_range_fields = () => {
        const range_wrapper = document.querySelectorAll('.range-field')

        range_wrapper.forEach(wrapper => {
            const range_input = wrapper.querySelector('input[type="range"]')
            const number_input = wrapper.querySelector('input[data-type="number"]')
            let minimum_value = parseInt(range_input.getAttribute('min'))
            if (isNaN(minimum_value)) {
                minimum_value = 1
            }

            function handle_input_change(event) {
                let target = event.target

                if (event.target.type === 'range') {
                    number_input.value = range_input.value
                    sessionStorage.setItem(`${APP_NAME}.${target.id}`, range_input.value)
                }

                if (event.target.type === 'number') {
                    target = range_input

                    if (number_input.value > 100) {
                        number_input.value = 100
                    } else if (number_input.value < minimum_value) {
                        number_input.value = minimum_value
                    }

                    range_input.value = number_input.value

                    sessionStorage.setItem(`${APP_NAME}.${target.id}`, number_input.value)
                }

                const min = target.min
                const max = target.max
                const val = target.value

                target.style.backgroundSize = ((val - min) * 100) / (max - min) + '% 100%'
            }

            sessionStorage.setItem(`${APP_NAME}.${range_input.id}`, range_input.value)
            sessionStorage.setItem(`${APP_NAME}.${number_input.id}`, number_input.value)

            range_input.addEventListener('input', handle_input_change)
            /* use 'change' event for number input, to allow for normal typing, clearing field, etc. */
            number_input.addEventListener('change', handle_input_change)
        })
    }

    const setup_tooltips = () => {
        const form_labels = document.querySelectorAll('.acf-form .acf-label:not(.screen-reader-text)')

        // I'm thinking we just move this to the page editor in an HTML block so this can
        // be localized without needing a deployment.
        const tooltip_messages = strings.tooltip_messages

        form_labels.forEach(label => {
            const label_element = label.querySelector('label')
            const label_for = label_element.getAttribute('for')
            const message_for_label = tooltip_messages[label_for]

            if (!message_for_label) return

            const tooltip_icon = document.createElement('a')
            const tooltip_icon_text = document.createElement('span')
            const tooltip_message = document.createElement('div')
            const tooltip_ID = label_for + '_tooltip'
            tooltip_icon.classList.add('roi-calculator-block__tooltip')
            tooltip_icon.setAttribute('href', '#')
            tooltip_message.classList.add('roi-calculator-block__tooltip-message', 'hidden')
            tooltip_message.setAttribute('role', 'tooltip')
            tooltip_message.setAttribute('id', tooltip_ID)

            const tooltip_target = document.getElementById(label_for)
            if (tooltip_target) {
                tooltip_target.setAttribute('aria-describedby', tooltip_ID)
            }

            tooltip_icon_text.classList.add('screen-reader-text')
            tooltip_icon_text.innerHTML = strings.view_field_tooltip
            tooltip_icon.append(tooltip_icon_text)

            function set_tooltop() {
                if (label_element.dataset.from) {
                    const value = document.getElementById(label_element.dataset.from).value
                    if (typeof value !== 'string' || !value) return
                    tooltip_message.innerHTML = message_for_label[value]
                } else {
                    tooltip_message.innerHTML = message_for_label
                }
            }

            set_tooltop()

            tooltip_icon.addEventListener('click', event => {
                set_tooltop()

                const this_message = event.target
                    .closest('.acf-label')
                    .querySelector('.roi-calculator-block__tooltip-message')
                this_message.classList.add('active')

                document.querySelectorAll('.roi-calculator-block__tooltip-message:not(.active)').forEach(message => {
                    message.classList.add('hidden')
                })

                if (this_message.classList.contains('hidden')) {
                    tooltip_message.setAttribute('tabindex', '-1')
                } else {
                    tooltip_message.removeAttribute('tabindex')
                }

                this_message.classList.toggle('hidden')
                this_message.classList.remove('active')

                stick_position(label, tooltip_message)
            })

            label_element.parentNode.append(tooltip_icon)
            label_element.parentNode.append(tooltip_message)

            function stick_position(label, element_to_stick) {
                if (element_to_stick.classList.contains('hidden')) {
                    return
                }

                const container = document.getElementById('roi-submission-form-wrapper')
                const tooltip = label.querySelector('.roi-calculator-block__tooltip')
                const fieldset = label.closest('fieldset')
                const label_data = label.getBoundingClientRect()
                const tooltip_data = tooltip.getBoundingClientRect()
                const fieldset_data = fieldset.getBoundingClientRect()
                const width_of_message = 254

                // element_to_stick.style.top = `${tooltip_data.top + 36}px`
                // element_to_stick.style.left = `${tooltip_data.left}px`
                // Need to offset based on the position of the parent step, rather than the full viewport
                element_to_stick.style.top = label_data.height + 16 + 'px'

                if (container.classList.contains('show-roi')) {
                    element_to_stick.style.left = tooltip_data.left - fieldset_data.left + 'px'
                } else {
                    element_to_stick.style.left = tooltip_data.left - fieldset_data.left - width_of_message + 'px'
                }
            }

            window.addEventListener('scroll', () => stick_position(label, tooltip_message))
            window.addEventListener('resize', () => stick_position(label, tooltip_message))
            document.addEventListener('DOMContentLoaded', () => stick_position(label, tooltip_message))
            document.addEventListener('keydown', event => {
                if (event.key === 'Escape') {
                    roi_calculator.close_tooltips()
                }
            })
            tooltip_icon.addEventListener('focusout', event => {
                roi_calculator.close_tooltips()
            })
        })
    }

    const setup_conditional_logic = () => {
        const number_of_sellers_status = {
            'customer-service': false,
            'enablement': true,
            'marketing': true,
            'sales': false,
        }

        const improve_options = strings.improve_options
        const team_type_text = strings.team_type_text
        const activity_text = strings.activity_text

        const form = document.getElementById('roi-submission-form')

        form.querySelectorAll(step_index_fields).forEach(field => {
            field.setAttribute('tabindex', '-1')
        })

        const functional_area = document.getElementById('functional_area')
        const improve = document.getElementById('improve')

        const currency_field_wrapper = document.querySelector('.revenue-currency-field__number')
        const currency = document.getElementById('currency')
        if (currency && currency_field_wrapper) {
            sessionStorage.setItem(`${APP_NAME}.currency`, currency.options[currency.selectedIndex].value)
            currency.addEventListener('change', e => {
                const selected = e.target.options[e.target.selectedIndex]
                const new_symbol = "'" + selected.dataset.symbol + "'"
                currency_field_wrapper.style.setProperty('--symbol', new_symbol)
                if (selected.dataset.position == 'after') {
                    currency_field_wrapper.classList.add('pos-after')
                } else {
                    currency_field_wrapper.classList.remove('pos-after')
                }
                sessionStorage.setItem(`${APP_NAME}.currency`, selected.value)
            })
        }
        const annual_revenue = document.getElementById('annual_revenue')
        annual_revenue.addEventListener('input', e => {
            sessionStorage.setItem(`${APP_NAME}.${e.target.id}`, e.target.value)
        })

        function improve_selection_changes() {
            sessionStorage.setItem(`${APP_NAME}.functional_area`, functional_area.value)

            if ('customer-service' === functional_area.value) {
                document.getElementById('chart-2').style.display = 'none'
                document.getElementById('chart-divider-text').style.display = 'none'
            } else {
                document.getElementById('chart-2').style.display = 'block'
                document.getElementById('chart-divider-text').style.display = 'block'
            }

            improve.innerHTML = ''
            for (const [key, value] of Object.entries(improve_options[functional_area.value])) {
                const option = document.createElement('option')

                if (key === '') {
                    option.setAttribute('selected', 'true')
                    option.setAttribute('data-i', '0')
                }

                option.setAttribute('value', key)
                option.innerHTML = value
                improve.append(option)
            }

            const number_of_sellers = document.getElementById('number_of_sellers')
            const number_of_sellers_row = number_of_sellers.closest('.acf-field')
            if (number_of_sellers_status[functional_area.value]) {
                number_of_sellers_row.style.display = 'block'
                number_of_sellers_row.removeAttribute('data-novalidate')
                number_of_sellers.setAttribute('required', true)
            } else {
                number_of_sellers.value = ''
                number_of_sellers_row.style.display = 'none'
                number_of_sellers_row.setAttribute('data-novalidate', 'true')
                number_of_sellers.removeAttribute('required')
            }

            document.getElementById('improve').value = ''

            const team_type = document.getElementById('number_of_team_members__team_type')
            team_type.innerText = team_type_text[functional_area.value]
        }

        sessionStorage.setItem(`${APP_NAME}.functional_area`, functional_area.value)
        functional_area.addEventListener('input', improve_selection_changes)
        document.addEventListener('DOMContentLoaded', improve_selection_changes)

        sessionStorage.setItem(`${APP_NAME}.improve`, improve.value)
        improve.addEventListener('input', function name(event) {
            sessionStorage.setItem(`${APP_NAME}.improve`, improve.value.replaceAll('-', ' '))

            const time_spent = document.getElementById('time_spent__activity_text')

            if (!this.value) {
                time_spent.innerText = ''
            } else {
                time_spent.innerText = activity_text[this.value]
            }
        })

        /**
         * Country Select Change
         */
        const country_field = document.getElementById('in_what_country_is_your_organization_headquartered')
        if (country_field) {
            country_field.addEventListener('input', function () {
                let show_state = false
                let state_options
                let region_type = 'state'
                switch (this.value) {
                    case 'United States':
                        state_options = strings.us_states
                        show_state = true
                        break

                    case 'Canada':
                        state_options = strings.canada_provices
                        show_state = true
                        region_type = 'province'
                        break

                    case 'Swaziland':
                        state_options = strings.switzerland_canton
                        show_state = true
                        region_type = 'canton'
                        break

                    default:
                        state_options = strings.state_empty
                        break
                }

                const state = document.querySelectorAll('#in_what_state_is_your_organization_headquartered')
                const state_field = state[0]
                const state_parent = state_field.closest('.acf-field')
                add_options_to_select_lists(state_options, state)
                state_parent.querySelector('.region-type').innerHTML = region_type

                if (show_state) {
                    state_field.setAttribute('required', true)
                    state_parent.removeAttribute('data-novalidate')
                    state_parent.style.display = 'block'
                } else {
                    state_field.removeAttribute('required')
                    state_parent.setAttribute('data-novalidate', 'true')
                    state_parent.style.display = 'none'
                }
            })
        }
    }

    const add_options_to_select_lists = (options_data, field = document.querySelectorAll('.static-select-list')) => {
        let options

        if (!field.length) return

        field.forEach(list => {
            switch (list.id) {
                case 'what_industry_are_you_in':
                    options = strings.what_industry_are_you_in
                    break

                case 'in_what_country_is_your_organization_headquartered':
                    options = strings.countries
                    break

                case 'in_what_state_is_your_organization_headquartered':
                    options = undefined === options_data ? strings.state_empty : options_data
                    break

                default:
                    break
            }

            const options_elements = []
            for (const [key, value] of Object.entries(options)) {
                if (key === 'please_select') {
                    options_elements.push(
                        `<option selected="true" data-i="0" value="${value.value}">${value.text}</option>`
                    )
                } else {
                    options_elements.push(`<option value="${value.value}">${value.text}</option>`)
                }
            }

            document.getElementById(list.id).innerHTML = options_elements.join('')
        })
    }

    const display_currency = (value, symbol = '$', position = 'before', currency_value) => {
        const annual_revenue_formatted = parseInt(`${value}`.replace(/[,.]/g, '')).toLocaleString(
            window.seismic_global_variables.seismic_site_lang
        )

        const currency = currency_value ? `<span class="screen-reader-text">${currency_value} </span>` : ''

        return `<span class="summary_currency" data-position="${position}" data-symbol="${symbol}">${currency}${annual_revenue_formatted}</span>`
    }

    const display_number = value => {
        return parseInt(`${value}`.replace(/[,.]/g, '')).toLocaleString(
            window.seismic_global_variables.seismic_site_lang
        )
    }

    const show_my_roi = () => {
        const roi_wrapper = document.getElementById('roi-submission-form-wrapper')
        const is_roi_marketo_form = roi_wrapper.classList.contains('roi-marketo-form')

        const calculate_button = document.getElementById('calculate_button')
        const submit_summary_button = document.getElementById('submit-for-summary')
        const submit_for_report_button = document.getElementById('submit-for-report')
        const submit_for_report_midline_cta = document.getElementById('submit-for-report-midline-cta')

        function recalculate_form() {
            roi_calculator.close_tooltips()
            document.getElementById('roi-submission-form-wrapper').classList.add('show-roi')

            $('.roi-accordion').slick('unslick').addClass('roi-accordion--show-results')

            const currency = document.getElementById('currency')

            const values = {
                functional_area: document.getElementById('functional_area').value,
                improve: document.getElementById('improve').value,
                number_of_team_members: document.getElementById('number_of_team_members').value,
                time_spent: document.getElementById('time_spent-alt').value,
                annual_revenue: document.getElementById('annual_revenue').value,
                number_of_sellers: document.getElementById('number_of_sellers').value,
                symbol: currency.querySelector(`option[value="${currency.value}"]`).dataset.symbol,
                position: currency.querySelector(`option[value="${currency.value}"]`).dataset.position,
            }

            const annual_revenue = display_currency(
                values.annual_revenue,
                values.symbol,
                values.position,
                currency.value
            )
            const number_of_sellers = display_number(values.number_of_sellers)
            const number_of_team_members = display_number(values.number_of_team_members)

            const improve_summary_text =
                values.improve === 'learning-coaching'
                    ? strings.learning_and_coaching
                    : values.improve.replaceAll('-', ' ')

            const summary_text = {
                functional_area: seismicUtilities.render(strings.summary_text.functional_area, {
                    value: values.functional_area,
                }),
                improve: seismicUtilities.render(strings.summary_text.improve, { value: improve_summary_text }),
                number_of_team_members: seismicUtilities.render(strings.summary_text.number_of_team_members, {
                    number_of_team_members: number_of_team_members,
                    functional_area: values.functional_area,
                }),
                time_spent: seismicUtilities.render(strings.summary_text.time_spent, { value: values.time_spent }),
                annual_revenue: seismicUtilities.render(strings.summary_text.annual_revenue, { value: annual_revenue }),
                number_of_sellers: seismicUtilities.render(strings.summary_text.number_of_sellers, {
                    value: number_of_sellers,
                }),
            }

            for (const [key, value] of Object.entries(summary_text)) {
                const label_summary = document.querySelector(`[data-summary_label="${key}"]`)

                const screenreader_text = document.createElement('span')
                screenreader_text.classList.add('screen-reader-text')
                screenreader_text.append(strings.summary_edit_screen_reader_text)

                if (label_summary) {
                    if (is_roi_marketo_form) {
                        const anchor = label_summary.querySelector('a')
                        anchor.innerHTML = value
                        anchor.append(screenreader_text)
                    } else {
                        const anchor = label_summary.querySelector('p')
                        anchor.innerHTML = value
                    }
                } else {
                    let summary_paragraph
                    if (is_roi_marketo_form) {
                        summary_paragraph = document.createElement('a')
                        summary_paragraph.href = '#'
                        summary_paragraph.innerHTML = value
                        summary_paragraph.append(screenreader_text)
                    } else {
                        summary_paragraph = document.createElement('p')
                        summary_paragraph.innerHTML = value
                    }

                    const summary_wrapper = document.createElement('div')
                    summary_wrapper.dataset.summary_label = key
                    summary_wrapper.classList.add('summary-label')
                    summary_wrapper.appendChild(summary_paragraph)

                    const label = document.querySelector(`[for="${key}"]`)
                    label.after(summary_wrapper)

                    if (is_roi_marketo_form) {
                        summary_paragraph.addEventListener('click', function (event) {
                            const field = event.target
                                .closest('.acf-field')
                                .querySelectorAll(
                                    'select, input[type="text"], input[type="email"], input[type="number"], input[type="range"]'
                                )

                            document.getElementById('roi-submission-form-wrapper').classList.add('show-roi--edit')
                            document.getElementById('submit-for-report').classList.remove('cta-primary-large')
                            document.getElementById('submit-for-report').classList.add('cta-secondary-large')

                            field[0].focus()
                        })
                    }
                }
            }
        }

        function productivity_chart_data() {
            const team_time_spent_percentage = parseInt(document.getElementById('time_spent-alt').value) * 0.01
            const number_of_team_members = parseInt(document.getElementById('number_of_team_members').value)
            const functional_area = document.getElementById('functional_area').value
            const use_case = document.getElementById('improve').value

            const efficiency_savings_rate = [
                { functional_area: 'enablement', use_case: 'content-management', value: 0.7 },
                { functional_area: 'enablement', use_case: 'learning-coaching', value: 0.5 },
                { functional_area: 'enablement', use_case: 'buyer-engagement', value: 0 },
                { functional_area: 'enablement', use_case: 'content-automation', value: 0 },
                { functional_area: 'enablement', use_case: 'enablement-planning', value: 0.3 },
                { functional_area: 'enablement', use_case: 'enablement-intelligence', value: 0.3 },

                { functional_area: 'sales', use_case: 'content-management', value: 0.2 },
                { functional_area: 'sales', use_case: 'learning-coaching', value: 0.75 },
                { functional_area: 'sales', use_case: 'buyer-engagement', value: 0.75 },
                { functional_area: 'sales', use_case: 'content-automation', value: 0.3 },
                { functional_area: 'sales', use_case: 'enablement-planning', value: 0 },
                { functional_area: 'sales', use_case: 'enablement-intelligence', value: 0.3 },

                { functional_area: 'marketing', use_case: 'content-management', value: 0.7 },
                { functional_area: 'marketing', use_case: 'learning-coaching', value: 0 },
                { functional_area: 'marketing', use_case: 'buyer-engagement', value: 0 },
                { functional_area: 'marketing', use_case: 'content-automation', value: 0.7 },
                { functional_area: 'marketing', use_case: 'enablement-planning', value: 0.3 },
                { functional_area: 'marketing', use_case: 'enablement-intelligence', value: 0.3 },

                { functional_area: 'customer-service', use_case: 'content-management', value: 0.2 },
                { functional_area: 'customer-service', use_case: 'learning-coaching', value: 0.2 },
                { functional_area: 'customer-service', use_case: 'buyer-engagement', value: 0.5 },
                { functional_area: 'customer-service', use_case: 'content-automation', value: 0 },
                { functional_area: 'customer-service', use_case: 'enablement-planning', value: 0 },
                { functional_area: 'customer-service', use_case: 'enablement-intelligence', value: 0.3 },
            ]

            const saved_time_for_repurpose = efficiency_savings_rate.filter(
                savings_rate => savings_rate.use_case === use_case && savings_rate.functional_area === functional_area
            )

            const net_percentage_of_time_saved = saved_time_for_repurpose[0].value * team_time_spent_percentage

            const work_weeks_in_year = 48
            const hours_per_week = 40
            const hours_per_year = 1920

            const time_savings = { worst: [], expected: [], best: [] }

            const constants = [
                { scenario: 'worst', year: 1, adjustment_factor_vs_medium_scenario: 0.7, phasing: 0.7 },
                { scenario: 'worst', year: 2, adjustment_factor_vs_medium_scenario: 0.7, phasing: 0.8 },
                { scenario: 'worst', year: 3, adjustment_factor_vs_medium_scenario: 0.7, phasing: 1.0 },

                { scenario: 'expected', year: 1, adjustment_factor_vs_medium_scenario: 1, phasing: 0.7 },
                { scenario: 'expected', year: 2, adjustment_factor_vs_medium_scenario: 1, phasing: 0.8 },
                { scenario: 'expected', year: 3, adjustment_factor_vs_medium_scenario: 1, phasing: 1.0 },

                { scenario: 'best', year: 1, adjustment_factor_vs_medium_scenario: 1.5, phasing: 0.7 },
                { scenario: 'best', year: 2, adjustment_factor_vs_medium_scenario: 1.5, phasing: 0.8 },
                { scenario: 'best', year: 3, adjustment_factor_vs_medium_scenario: 1.5, phasing: 1.0 },
            ]

            constants
                .sort((a, b) => a.year - b.year)
                .forEach(constant => {
                    const capacity = net_percentage_of_time_saved * constant.adjustment_factor_vs_medium_scenario
                    const basic_calc = hours_per_week * work_weeks_in_year * number_of_team_members * constant.phasing

                    time_savings[constant.scenario].push(Math.round(capacity * basic_calc))
                })

            time_savings.year_3_team_mebers = Math.round(time_savings.expected[2] / hours_per_year)

            return time_savings
        }

        function revenue_chart_data() {
            const baseline_revenue = parseInt(`${document.getElementById('annual_revenue').value}`.replace(/[,.]/g, ''))

            const revenue_win_rate = 0.4
            const risk_adjustment = -0.05

            const revenue = { worst: [], expected: [], best: [] }
            const prod_impact_accum = { worst: 1, expected: 1, best: 1 }

            const constants = [
                { scenario: 'worst', year: 1, productivity_impact: 0.0025, effectiveness_impact: 0 },
                { scenario: 'worst', year: 2, productivity_impact: 0.005, effectiveness_impact: 0 },
                { scenario: 'worst', year: 3, productivity_impact: 0.01, effectiveness_impact: 0 },

                { scenario: 'expected', year: 1, productivity_impact: 0.0025, effectiveness_impact: 0.0025 },
                { scenario: 'expected', year: 2, productivity_impact: 0.005, effectiveness_impact: 0.005 },
                { scenario: 'expected', year: 3, productivity_impact: 0.01, effectiveness_impact: 0.01 },

                { scenario: 'best', year: 1, productivity_impact: 0.0075, effectiveness_impact: 0.0075 },
                { scenario: 'best', year: 2, productivity_impact: 0.01, effectiveness_impact: 0.015 },
                { scenario: 'best', year: 3, productivity_impact: 0.0125, effectiveness_impact: 0.03 },
            ]

            constants.forEach(constant => {
                prod_impact_accum[constant.scenario] =
                    prod_impact_accum[constant.scenario] * (constant.productivity_impact + 1)

                const revenue_multiplier = prod_impact_accum[constant.scenario]

                const eff_impact_revenue_multiplier = 1 + constant.effectiveness_impact / revenue_win_rate

                const revenue_lift =
                    baseline_revenue * revenue_multiplier * eff_impact_revenue_multiplier - baseline_revenue

                const risk_adjusted_revenue_lift = revenue_lift * (1 + risk_adjustment)

                revenue[constant.scenario].push(Math.round(risk_adjusted_revenue_lift))
            })

            return revenue
        }

        function calulate_charts(productivity_chart_data, revenue_chart_data) {
            const currency_abbreviation = document.getElementById('currency').value

            const chart_params = {
                labels: {
                    y_axis: strings.chart_strings.y_axis,
                    lines: strings.chart_strings.lines,
                },
                chart_1: {
                    title: strings.chart_strings.chart_1_title,
                    data: {
                        worst: productivity_chart_data.worst,
                        expected: productivity_chart_data.expected,
                        best: productivity_chart_data.best,
                    },
                },
                chart_2: {
                    title: seismicUtilities.render(strings.chart_strings.chart_2_title, {
                        currency_abbreviation: currency_abbreviation,
                    }),
                    data: {
                        worst: revenue_chart_data.worst,
                        expected: revenue_chart_data.expected,
                        best: revenue_chart_data.best,
                    },
                },
            }

            /**
             * Generate charts
             */
            roi_calculator.render_charts(chart_params)

            /**
             * Productivity Statement
             */
            const hours_saved = display_number(productivity_chart_data.expected[2])
            const team_members_saved = display_number(productivity_chart_data.year_3_team_mebers)
            const functional_area = document.getElementById('functional_area').value
            const improve = document.getElementById('improve').value
            const improve_text =
                improve === 'learning-coaching' ? strings.learning_and_coaching : improve.replaceAll('-', ' ')

            const cloning_statement = parseInt(team_members_saved)
                ? seismicUtilities.render(strings.cloning_statement, {
                      team_members_saved: team_members_saved,
                      improve_text: improve_text,
                  })
                : ``

            document.getElementById('productivity_chart_legend').innerHTML = seismicUtilities.render(
                strings.productivity_chart_legend,
                { functional_area: functional_area, hours_saved: hours_saved, cloning_statement: cloning_statement }
            )

            /**
             * Revenue Statement
             */
            const symbol = currency.querySelector(`option[value="${currency_abbreviation}"]`).dataset.symbol
            const position = currency.querySelector(`option[value="${currency_abbreviation}"]`).dataset.position
            const revenue_expected_year_3 = display_currency(
                revenue_chart_data.expected[2],
                symbol,
                position,
                currency_abbreviation
            )

            document.getElementById('revenue_chart_legend').innerHTML = seismicUtilities.render(
                strings.revenue_chart_legend,
                { revenue_expected_year_3: revenue_expected_year_3 }
            )
        }

        function submit_form(event) {
            event.preventDefault() // for when used with anchor tags

            roi_calculator.close_tooltips()

            const popup_forms = $('.popup-form')

            popup_forms.smodal({
                blockerClass: 'jquery-smodal form-modal form-modal--large theme-dark roi-marketo-form',
                fadeDuration: 500,
            })

            popup_forms.on($.smodal.BEFORE_OPEN, function (event, modal) {
                pill_marketo_form(popup_forms.data('formId'), ['cta-primary-large', 'theme-light'])

                const wp_form_fields = {
                    annual_revenue: document.getElementById('annual_revenue').value,
                    currency: document.getElementById('currency').value,
                    date: new Date().toUTCString(),
                    functional_area: document.getElementById('functional_area').value,
                    guid: document.getElementById('roi_guid').value,
                    report_url: document.getElementById('roi_report_url').value,
                    improve: document.getElementById('improve').value.replaceAll('-', ' '),
                    number_of_sellers: document.getElementById('number_of_sellers').value,
                    number_of_team_members: document.getElementById('number_of_team_members').value,
                    time_spent_alt: document.getElementById('time_spent-alt').value,
                }

                // const marketo_form = document.getElementById('mktoForm_4377')
                const marketo_form = document.querySelector('#standalone-form form')
                const marketo_form_fields = {
                    annual_revenue: marketo_form.querySelector('[name="AnnualRevenue"]'),
                    currency: marketo_form.querySelector('[name="Annual_Revenue_Currency__c"]'),
                    date: marketo_form.querySelector('[name="ROI_Calcluator_Date__c"]'),
                    functional_area: marketo_form.querySelector('[name="Team_Functional_Area__c"]'),
                    guid: marketo_form.querySelector('[name="rOICalculatorGUID"]'),
                    report_url: marketo_form.querySelector('[name="Report_URL__c"]'),
                    improve: marketo_form.querySelector('[name="Pain_Point__c"]'),
                    number_of_sellers: marketo_form.querySelector('[name="Number_of_Sales_People__c"]'),
                    number_of_team_members: marketo_form.querySelector('[name="Team_Size__c"]'),
                    time_spent_alt: marketo_form.querySelector('[name="Pain_Point_Time_Spent__c"]'),
                }

                for (const [key, field] of Object.entries(marketo_form_fields)) {
                    if (field) {
                        field.value = wp_form_fields[key]
                    }
                }

                if (!event.target.querySelector('.cta-secondary-large')) {
                    const close_button = document.createElement('button')
                    const close_button_span = document.createElement('span')
                    close_button.setAttribute('type', 'button')
                    close_button.setAttribute('rel', 'smodal:close')
                    close_button.classList.add('cta-secondary-large', 'theme-light')
                    close_button_span.innerHTML = strings.close
                    close_button.append(close_button_span)

                    close_button.addEventListener('click', () => {
                        $.smodal.close()
                    })

                    event.target.querySelector('.mktoButtonWrap').append(close_button)
                }

                MktoForms2.whenReady(function (form) {
                    form.onSuccess((vals, thanksURL) => {
                        document.getElementById('industry').value = vals.Industry
                        document.getElementById('company').value = vals.Company
                        const formId = parseInt(form.getId())
                        const redirect_url = seismicUtilities.scrubUrl(document.getElementById('redirect').value)

                        /* Submit button routine needed to "save" form and obviate "are you sure you want to leave the page" warning */
                        const submit_button = document.createElement('input')
                        submit_button.setAttribute('type', 'submit')
                        submit_button.setAttribute('name', 'roi-submission')
                        submit_button.setAttribute('id', 'roi-submit')
                        submit_button.setAttribute('value', 'Submit')
                        submit_button.classList.add('submit', 'hidden')

                        document.getElementById('roi-submission-form').append(submit_button)
                        document.getElementById('roi-submit').click()

                        var buttonrow = document.getElementsByClassName('mktoButtonWrap')
                        var waitImg = document.getElementById('waitImg')
                        buttonrow[0].appendChild(waitImg)
                        waitImg.classList.add('show')

                        // const submissionAjaxUrlSpan = document.getElementById('submissionAjaxUrl');
                        // const submissionSaveKeySpan = document.getElementById('submissionSaveKey');
                        // const submissionAjaxUrl = submissionAjaxUrlSpan.innerHTML;
                        // const submissionSaveKey = submissionSaveKeySpan.innerHTML;
                        // //console.log ('calling ajax save, submissionAjaxUrl = ' + submissionAjaxUrl + ', submissionSaveKey = ' + submissionSaveKey);

                        // const submission_data = {
                        //     guid: wp_form_fields['guid'],
                        //     redirect: redirect_url, //wp_form_fields['report_url']
                        //     company: vals.Company,
                        //     functional_area: wp_form_fields['functional_area'],
                        //     improve: document.getElementById('improve').value, // wp_form_fields['improve'],
                        //     number_of_team_members: wp_form_fields['number_of_team_members'],
                        //     time_spent: wp_form_fields['time_spent_alt'],
                        //     annual_revenue: wp_form_fields['annual_revenue'],
                        //     currency: wp_form_fields['currency'] ,
                        //     number_of_sellers: wp_form_fields['number_of_sellers'],
                        //     industry: vals.Industry,
                        // }

                        // jQuery.ajax({
                        //     type : "post",
                        //     dataType : "json",
                        //     url : submissionAjaxUrl,
                        //     data : {'action': 'roi_save_submission', 'submission_data': submission_data, 'nonce': submissionSaveKey},
                        //     success: function(response) { }
                        // });

                        if (formId != 4377 && redirect_url != false && redirect_url != '') {
                           window.location.href = redirect_url
                        }

                        return false
                    })
                })
            })
        }

        if (submit_summary_button) {
            submit_summary_button.addEventListener('click', function () {
                if (roi_calculator.validate($(this)) === true) {
                    recalculate_form()

                    if (
                        typeof sega4 == 'object' &&
                        sega4.hasOwnProperty('roiCalculator') &&
                        typeof sega4.roiCalculator.log == 'function'
                    ) {
                        sega4.roiCalculator.log('submit', 3)
                    }

                    calulate_charts(productivity_chart_data(), revenue_chart_data())

                    if (typeof sticky_init != 'undefined') {
                        window.addEventListener('resize', sticky_init)
                        document.addEventListener('scroll', sticky_init)
                        document.addEventListener('DOMContentLoaded', sticky_init)    
                    }
                }
            })
        }

        if (calculate_button) {
            calculate_button.addEventListener('click', function () {
                const steps = document.querySelectorAll('.roi-calculator-block .roi-calculator-block__form-step')
                const validated = []

                steps.forEach(step => validated.push(roi_calculator.validate($(step))))

                if (!validated.includes(false)) {
                    recalculate_form()

                    if (
                        typeof sega4 == 'object' &&
                        sega4.hasOwnProperty('roiCalculator') &&
                        typeof sega4.roiCalculator.log == 'function'
                    ) {
                        sega4.roiCalculator.log('submit', 4)
                    }

                    Chart.getChart('roi-chart-1').destroy()
                    Chart.getChart('roi-chart-2').destroy()
                    calulate_charts(productivity_chart_data(), revenue_chart_data())

                    document.getElementById('roi-submission-form-wrapper').classList.remove('show-roi--edit')
                    document.getElementById('submit-for-report').classList.add('cta-primary-large')
                    document.getElementById('submit-for-report').classList.remove('cta-secondary-large')
                }
            })
        }

        if (submit_for_report_button && is_roi_marketo_form) {
            submit_for_report_button.addEventListener('click', submit_form)
        }

        if (submit_for_report_midline_cta && is_roi_marketo_form) {
            submit_for_report_midline_cta.addEventListener('click', submit_form)
        }
    }

    const roi_ajax_submission = () => {
        const roi_wrapper = document.getElementById('roi-submission-form-wrapper')
        const is_roi_marketo_form = roi_wrapper.classList.contains('roi-marketo-form')

        if (is_roi_marketo_form) return

        const submit_for_summary = document.getElementById('submit-for-summary')

        if (submit_for_summary) {
            submit_for_summary.addEventListener('click', function (event) {
                if (roi_calculator.validate($(this)) === false) return

                grecaptcha.ready(function () {
                    grecaptcha
                        .execute('6LedangUAAAAAB-Ui5rF3BFXXmq8JNnAluCmVCJe', { action: 'form_submission' })
                        .then(function (token) {
                            document.getElementById('g-recaptcha-response').value = token

                            const functional_area = document.getElementById('functional_area').value
                            const improve = document.getElementById('improve').value
                            const number_of_team_members = document.getElementById('number_of_team_members').value
                            const time_spent = document.getElementById('time_spent').value
                            const annual_revenue = document.getElementById('annual_revenue').value
                            const currency = document.getElementById('currency').value
                            const number_of_sellers = document.getElementById('number_of_sellers').value
                            const guid = document.getElementById('roi_guid').value
                            const industry = document.getElementById('what_industry_are_you_in').value
                            const company = document.getElementById(
                                'what_is_the_name_of_your_company_or_organization'
                            ).value
                            const country = document.getElementById(
                                'in_what_country_is_your_organization_headquartered'
                            ).value
                            const state = document.getElementById(
                                'in_what_state_is_your_organization_headquartered'
                            ).value
                            const what_is_your_first_name = document.getElementById('what_is_your_first_name').value
                            const what_is_your_last_name = document.getElementById('what_is_your_last_name').value
                            const what_is_your_email_address =
                                document.getElementById('what_is_your_email_address').value
                            const roi_report_url = document.getElementById('roi_report_url').value

                            const nonce = document.getElementById('roi_submission_form_submit').value

                            const currentDate = new Date()
                            const iso8601Date = currentDate.toISOString()

                            const acf_data = {
                                functional_area: functional_area,
                                improve: improve,
                                number_of_team_members: number_of_team_members,
                                time_spent: time_spent,
                                annual_revenue: annual_revenue,
                                currency: currency,
                                number_of_sellers: number_of_sellers,
                                guid: guid,
                                industry: industry,
                                company: company,
                            }

                            const marketo_data = {
                                company: company,
                                Industry: industry,
                                country: country,
                                state: state,
                                firstName: what_is_your_first_name,
                                lastName: what_is_your_last_name,
                                email: what_is_your_email_address,
                                Team_Functional_Area__c: functional_area,
                                Pain_Point__c: improve,
                                Team_Size__c: number_of_team_members,
                                Pain_Point_Time_Spent__c: time_spent,
                                AnnualRevenue: annual_revenue,
                                Annual_Revenue_Currency__c: currency,
                                Number_of_Sales_People__c: number_of_sellers,
                                rOICalculatorGUID: guid,
                                Report_URL__c: roi_report_url,
                                ROI_Calcluator_Date__c: iso8601Date,
                            }

                            //console.log(new Date().toString() + ' calling process form via ajax');
                            fetch(ajax_object.ajax_url, {
                                method: 'POST',
                                header: {
                                    'Content-Type': 'application/json',
                                },
                                body: new URLSearchParams({
                                    'action': 'process_form',
                                    'roi_submission_ajax': true,
                                    'roi-submission': true,
                                    'roi_submission_form_submit': nonce,
                                    'acf': JSON.stringify(acf_data),
                                    'marketo': JSON.stringify(marketo_data),
                                    'captcha': true,
                                    'g-recaptcha-response': token,
                                }),
                            })
                                .then(response => response.text())
                                .then(data => {
                                    if (data.includes('captcha-failed')) {
                                        const submit_for_report = document.getElementById('submit-for-report')
                                        const message = document.createElement('p')
                                        message.classList.add('text-body-4', 'text-center')
                                        message.innerHTML = strings.validation_messages.captcha.text
                                        submit_for_report.after(message)
                                    }
                                })
                                .catch(error => {
                                    console.error('Error:', error)
                                })
                        })
                })
            })
        }
    }

    const start_roi_form = () => {
        function start_roi_action_button(event) {
            event.preventDefault()

            document
                .querySelector('.form-step-1')
                .querySelectorAll(step_index_fields)
                .forEach(field => {
                    field.removeAttribute('tabindex')
                })

            const intro = document.querySelector('.roi-introduction')

            document.getElementById('roi-calculator-progress').querySelector('li').setAttribute('aria-current', 'step')
            intro.classList.add('roi-introduction--hidden')
            document.getElementById('roi-submission-form-wrapper').classList.remove('roi-calculator-block--disabled')
            document.getElementById('start-roi-form-overlay-button').style.display = 'none'
            window.scrollTo(0, document.body.scrollHeight)

            setTimeout(() => {
                intro.style.display = 'none'
            }, 500)
        }

        document.getElementById('start-roi-form-button').addEventListener('click', start_roi_action_button)
        document.getElementById('start-roi-form-overlay-button').addEventListener('click', start_roi_action_button)
    }

    const limit_field_input = () => {
        const form = document.getElementById('roi-submission-form')
        const number_fields = form.querySelectorAll('[data-type="number"]')

        if (!number_fields.length) return

        number_fields.forEach(field => {
            field.addEventListener('keydown', function (event) {
                // I've allowed meta keys and copy+paste
                const ignore = [8, 9, 16, 32, 37, 38, 39, 40, 65, 67, 86, 88, 91, 93]

                if (ignore.includes(event.keyCode)) return

                const validNumber = new RegExp(/[0-9,\,\.]/)
                const input = event.key

                if (!validNumber.test(input)) event.preventDefault()
            })
        })
    }

    const prevent_accidental_submission = () => {
        document.querySelectorAll('select, [type="text"], [type="number"], [type="range"]').forEach(field => {
            field.addEventListener('keydown', function (event) {
                if ('select' === this.tagName.toLowerCase()) {
                    return
                }

                if ('Enter' === event.code || 13 === event.keyCode) {
                    // prevent returns from submitting the form.
                    event.preventDefault()
                    return false
                }
            })
        })
    }

    const is_valid_email_address = field => {
        const email_address = field[0].value

        if (!email_address) return

        const email_address_array = email_address.split('@')
        const domain = `@${email_address_array[1]}`
        const blacklist = window.internal_blacklist

        for (var blocked_email in blacklist) {
            const email_validated = domain.toLowerCase().indexOf(blacklist[blocked_email].toLowerCase())

            if (-1 !== email_validated) return false
        }

        return true
    }

    const is_email_address = field => {
        const email_address = field[0].value
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
        const is_valid = regex.test(email_address)

        if (!is_valid) return false

        return true
    }

    const init = () => {
        setup_increment_buttons()
        setup_range_fields()
        setup_tooltips()
        setup_conditional_logic()
        setup_progress_indicator()
        add_options_to_select_lists()
        show_my_roi()
        start_roi_form()
        prevent_accidental_submission()
        limit_field_input()
        roi_ajax_submission()
    }

    init()

    return Methods
})(jQuery)



